module.exports = __webpack_public_path__ + "static/media/orangeTheme-girl.01ab8434.svg";